import PublicationBookingPlanner from '@components/PublicationBookingPlanner'

const BookingPlanner = () => (
  <div id="main-stage" style={{ position: 'relative' }}>
    {/*
     // @ts-expect-error TS2741 */}
    <PublicationBookingPlanner />
  </div>
)

export default BookingPlanner
